var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.teste)?_vm._t("original"):_vm._e(),_vm._v(" "),(_vm.teste)?_vm._t("teste"):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }